import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Talent } from "../../Types/Talent";
import { TalentSpecializations } from "../../Types/General";

export interface TalentMarketplaceFiltersState {
    Skill: string[];
    Level: string;
    Specialization: string;
    WorkSite: string;
}
const initialState = {
    Skill: [],
    Level: '', 
    Specialization: '',
    WorkSite: ''
}
export const talentMarketplaceFiltersSlice = createSlice({
    name: 'TalentMarketplaceFilters',
    initialState,
    reducers: {
        resetMarketplaceFilters() {
            return initialState;
        },
        setSkillFilter(state, action: PayloadAction<TalentMarketplaceFiltersState["Skill"]>) {
            //@ts-ignore
            state.Skill = action.payload;
        },
        setLevelFilter(state, action: PayloadAction<TalentMarketplaceFiltersState["Level"]>) {
            state.Level = action.payload;
        },
        setSpecializationFilter(state, action: PayloadAction<TalentMarketplaceFiltersState["Specialization"]>) {
            state.Specialization = action.payload;
        },
        setWorkSiteFilter(state, action: PayloadAction<TalentMarketplaceFiltersState["WorkSite"]>) {
            state.WorkSite = action.payload;
        }
    }
})

export const {
    resetMarketplaceFilters,
    setSkillFilter,
    setLevelFilter,
    setSpecializationFilter,
    setWorkSiteFilter
} = talentMarketplaceFiltersSlice.actions

export default talentMarketplaceFiltersSlice.reducer

